import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {FilterState} from './document-filter/reducer/filter.reducer';
import {SearchItemsState} from './document-search-item/reducer/search-items.reducer';
import {DocumentSearchResultState} from './document-search-result/reducer/document-search-result.reducer';
import {NexiaBasketObject} from '../../models/nexia-basket-object';
import {selectNexiaBasketFeature} from '../nexia-basket/nexia-basket-selectors';


export const selectDocumentSearchFilterFeature = createFeatureSelector<FilterState>(StoreKeys.FILTERS);

export const selectDocumentSearchFilterDatas = createSelector(selectDocumentSearchFilterFeature, state => state.datas);
export const selectDocumentSearchFilterDatasFilterItems = createSelector(selectDocumentSearchFilterFeature, state => state.datas.filterItems);
export const selectDocumentSearchFilterDatasLastAgg = createSelector(selectDocumentSearchFilterFeature, state => state.datas.lastAgg);

export const selectDocumentSearchItemFeature = createFeatureSelector<SearchItemsState>(StoreKeys.SEARCH_ITEMS);

export const selectDocumentSearchItemDatas = createSelector(selectDocumentSearchItemFeature, state => state.datas);

export const selectDocumentSearchResultFeature = createFeatureSelector<DocumentSearchResultState>(StoreKeys.DOCUMENT_SEARCH_RESULT);
export const selectDocumentSearchResultLoading = createSelector(selectDocumentSearchResultFeature, state => state.loading);
export const selectDocumentSearchResultLoadAgg = createSelector(selectDocumentSearchResultFeature, state => state.loadAgg);

export const selectDocumentSearchResultDatas = createSelector(selectDocumentSearchResultFeature, state => state.datas);

export const selectDocumentSearchResultDatasContent = createSelector(selectDocumentSearchResultDatas, state => state?.content);

export const selectDocumentFromBasketData = createSelector(selectNexiaBasketFeature, state => Object.values(state?.datas).map((basketObjects: NexiaBasketObject[]) => basketObjects.map((basketObject: NexiaBasketObject) => basketObject.details))[0]);
